import {
  CreateManyGeneralRules,
  PaymentPlanDealsDiscountsList
} from 'pages/payment_deals/payment_plan_deals';
import { CreateProductPlanDealRule } from 'pages/payment_deals/payment_plan_deals/CreateManyProductRule';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'discount_campaigns',
  label: 'Descontos para inadimplência',
  list: PaymentPlanDealsDiscountsList,
  create: CreateManyGeneralRules,
  show: CreateProductPlanDealRule,
  actions: ['create', 'list', 'show', 'delete'],
  parentName: 'payment_deals'
};

export default generateResources(resource);
